import React, { useCallback, useEffect, useState } from 'react';

import { Dialog, useDialogUIState } from '@rbilabs/components-library/build/components/dialog';
import { useIntl } from 'react-intl';

import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { useNetworkContext } from 'state/network';
import * as location from 'utils/location';

function ErrorNetwork() {
  const mParticle = useMParticleContext();
  const { formatMessage } = useIntl();
  const dialog = useDialogUIState();
  const { hasNetworkError } = useNetworkContext();
  const [browsingOffline, setBrowsingOffline] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  const onReload = useCallback(() => {
    mParticle.trackEvent({ name: CustomEventNames.NETWORK_ERROR_RELOAD, type: EventTypes.Other });
    location.reload();
  }, [mParticle]);

  useEffect(() => {
    if (!hasOpened && hasNetworkError && !browsingOffline) {
      mParticle.trackEvent({ name: CustomEventNames.NETWORK_ERROR, type: EventTypes.Other });
      setHasOpened(true);
      dialog.show();
    }
  }, [browsingOffline, dialog, hasNetworkError, hasOpened, mParticle]);

  return (
    <Dialog
      data-testid="error-network-dialog"
      dialog={dialog}
      headerText={formatMessage({ id: 'lostNetworkConnectivity' })}
      bodyText={formatMessage({ id: 'checkNetworkSettings' })}
      {...{ 'aria-label': formatMessage({ id: 'lostNetworkConnectivity' }) }}
      closeButtonText={formatMessage({ id: 'close' })}
      onDismiss={() => setBrowsingOffline(true)}
      buttons={[
        {
          text: formatMessage({ id: 'reload' }),
          onClick: onReload,
        },
      ]}
    />
  );
}

export default ErrorNetwork;
